"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Table = _styledComponents.default.table(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  border-spacing: 0;\n  text-align: left;\n  border-radius: 2px;\n  thead {\n    background: ", ";\n  }\n  tbody {\n    background: ", ";\n    tr.divider {\n      height: 12px;\n      td {\n        background: ", ";\n        opacity: 0.5;\n        height: 100%;\n        width: 100%;\n        font-weight: 500;\n      }\n    }\n  }\n  th,\n  td {\n    border: 1px solid ", ";\n  }\n  th {\n    border-bottom: 1px solid ", ";\n  }\n  p {\n    margin: 0;\n  }\n  ", "\n  ", "\n  tr.success > td:first-of-type {\n    border-left: 4px solid ", ";\n    margin-left: -4px;\n  }\n  tr.warning > td:first-of-type {\n    border-left: 4px solid ", ";\n    margin-left: -4px;\n  }\n  tr.critical > td:first-of-type {\n    border-left: 4px solid ", ";\n    margin-left: -4px;\n  }\n"])), function (props) {
  return props.width || "100%";
}, function (props) {
  return props.theme.colors.white[700];
}, function (props) {
  return props.theme.colors.white[900];
}, function (props) {
  return props.theme.colors.white[700];
}, function (props) {
  return props.theme.colors.white[500];
}, function (props) {
  return props.theme.colors.white[300];
}, function (props) {
  if (props.space === "tight") {
    return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        p {\n          font-size: 0.8em;\n        }\n        th,\n        td {\n          padding: 0.2em 0.6em;\n        }\n      "])));
  }

  if (props.size === "sm") {
    return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        th {\n          font-size: 13px;\n        }\n        td {\n          font-size: 12px;\n          & > input {\n            font-size: initial;\n          }\n        }\n        th,\n        td {\n          padding: 0.3em 0.5em;\n        }\n      "])));
  }

  if (props.size === "xs") {
    return (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        th {\n          font-size: 12px;\n        }\n        td {\n          font-size: 11px;\n          & > input {\n            font-size: initial;\n          }\n        }\n        th,\n        td {\n          padding: 0.2em 0.4em;\n        }\n      "])));
  }

  return (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      p {\n        font-size: 0.9em;\n      }\n      th,\n      td {\n        padding: 0.5em 0.8em;\n      }\n    "])));
}, function (props) {
  if (props.hoverHighlight) {
    return (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        tbody > tr:hover {\n          cursor: pointer;\n          color: ", ";\n          transition: 150ms;\n        }\n      "])), props.theme.colors.brand[500]);
  }
}, function (props) {
  return props.theme.colors.green[500];
}, function (props) {
  return props.theme.colors.orange[500];
}, function (props) {
  return props.theme.colors.red[500];
});

var _default = Table;
exports.default = _default;